<script setup>
import { ref, onMounted } from 'vue';
import { RouterLink, useRouter } from 'vue-router';

const router = useRouter();

// Estados para hovers
const hoverStates = ref({});

// Estados para carruseles
const currentSlide1 = ref(0);
const currentSlide2 = ref(0);
const currentSlide3 = ref(0);

// Datos de proyectos
const projects1 = ref([
  {
    id: 1,
    name: 'Modo Oscuro',
    description: 'Toggle modo claro/oscuro con CSS Variables y localStorage',
    color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    demoRoute: '/demos/modo-claro-oscuro'
  },
  {
    id: 2,
    name: 'Responsive Control',
    description: 'Diseño responsive con control de breakpoints interactivo',
    color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    demoRoute: '/demos/responsive-control'
  },
  {
    id: 3,
    name: 'Animaciones Scroll',
    description: 'Animaciones al scroll con CSS y JavaScript nativo',
    color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    demoRoute: '/demos/animaciones-scroll'
  },
  {
    id: 4,
    name: 'Web Ficticia',
    description: 'Sitio web completo creado desde cero con diseño moderno',
    color: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    demoRoute: '/demos/web-ficticia'
  },
  {
    id: 5,
    name: 'Web Mejorada',
    description: 'Rediseño y optimización de sitio web existente',
    color: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    demoRoute: '/demos/web-mejorada'
  },
  {
    id: 6,
    name: 'Clon Netflix',
    description: 'Réplica de interfaz de Netflix con carrusel interactivo',
    color: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    demoRoute: '/demos/clon-netflix'
  }
]);

const projects2 = ref([
  {
    id: 7,
    name: 'Proyecto 7',
    description: 'Proyecto de ejemplo para servicio 2',
    color: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
    demoRoute: '/demos/proyecto-7'
  },
  {
    id: 8,
    name: 'Proyecto 8',
    description: 'Proyecto de ejemplo para servicio 2',
    color: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
    demoRoute: '/demos/proyecto-8'
  },
  {
    id: 9,
    name: 'Proyecto 9',
    description: 'Proyecto de ejemplo para servicio 2',
    color: 'linear-gradient(135deg, #fad0c4 0%, #ffd1ff 100%)',
    demoRoute: '/demos/proyecto-9'
  }
]);

const projects3 = ref([
  {
    id: 10,
    name: 'Proyecto 10',
    description: 'Proyecto de ejemplo para servicio 3',
    color: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
    demoRoute: '/demos/proyecto-10'
  },
  {
    id: 11,
    name: 'Proyecto 11',
    description: 'Proyecto de ejemplo para servicio 3',
    color: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)',
    demoRoute: '/demos/proyecto-11'
  },
  {
    id: 12,
    name: 'Proyecto 12',
    description: 'Proyecto de ejemplo para servicio 3',
    color: 'linear-gradient(135deg, #d4fc79 0%, #96e6a1 100%)',
    demoRoute: '/demos/proyecto-12'
  }
]);

// Método para navegar a demo
const navigateToDemo = (demoRoute, projectId, event) => {
  console.log('🚀 Navegando a demo:', demoRoute, 'ID:', projectId);

  // Prevenir que el evento se propague al carrusel
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  // Navegar directamente
  router.push(demoRoute);

  // También activar modo demo manualmente para asegurar
  window.dispatchEvent(new CustomEvent('activate-demo-mode', {
    detail: { projectId }
  }));
};

// Métodos para hover
const hoverCard = (cardId) => {
  hoverStates.value[cardId] = true;
};

const resetCard = (cardId) => {
  hoverStates.value[cardId] = false;
};

// Métodos para carrusel - CORREGIDOS
const goToSlide = (carousel, index, totalSlides) => {
  if (index < 0) {
    index = totalSlides - 1; // Ir al último slide
  } else if (index >= totalSlides) {
    index = 0; // Volver al primer slide
  }

  if (carousel === 1) currentSlide1.value = index;
  if (carousel === 2) currentSlide2.value = index;
  if (carousel === 3) currentSlide3.value = index;
};

// Touch events para carrusel - COMPLETAMENTE CORREGIDOS
const setupCarousel = () => {
  const tracks = document.querySelectorAll('.carousel-track');

  tracks.forEach((track, index) => {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let startTime = 0;

    const handleTouchStart = (e) => {
      // Solo iniciar drag si no es un botón
      if (e.target.closest('.carousel-demo-btn')) {
        return;
      }

      startX = e.touches[0].clientX;
      currentX = startX;
      isDragging = true;
      startTime = Date.now();
      track.style.transition = 'none';
    };

    const handleTouchMove = (e) => {
      if (!isDragging) return;

      currentX = e.touches[0].clientX;
      const diff = startX - currentX;

      let currentSlide;
      if (index === 0) currentSlide = currentSlide1.value;
      else if (index === 1) currentSlide = currentSlide2.value;
      else currentSlide = currentSlide3.value;

      track.style.transform = `translateX(calc(-${currentSlide * 100}% - ${diff}px))`;
    };

    const handleTouchEnd = (e) => {
      if (!isDragging) return;

      isDragging = false;
      track.style.transition = 'transform 0.3s ease';

      const diff = startX - currentX;
      const timeDiff = Date.now() - startTime;

      // Solo cambiar slide si fue un deslizamiento significativo
      if (Math.abs(diff) > 50 || (Math.abs(diff) > 20 && timeDiff < 300)) {
        let currentSlide, totalSlides;
        if (index === 0) {
          currentSlide = currentSlide1.value;
          totalSlides = projects1.value.length;
          if (diff > 0) {
            // Deslizar hacia la izquierda -> siguiente slide
            goToSlide(1, currentSlide + 1, totalSlides);
          } else {
            // Deslizar hacia la derecha -> slide anterior
            goToSlide(1, currentSlide - 1, totalSlides);
          }
        } else if (index === 1) {
          currentSlide = currentSlide2.value;
          totalSlides = projects2.value.length;
          if (diff > 0) {
            goToSlide(2, currentSlide + 1, totalSlides);
          } else {
            goToSlide(2, currentSlide - 1, totalSlides);
          }
        } else {
          currentSlide = currentSlide3.value;
          totalSlides = projects3.value.length;
          if (diff > 0) {
            goToSlide(3, currentSlide + 1, totalSlides);
          } else {
            goToSlide(3, currentSlide - 1, totalSlides);
          }
        }
      }

      // Resetear la posición
      let currentSlide;
      if (index === 0) currentSlide = currentSlide1.value;
      else if (index === 1) currentSlide = currentSlide2.value;
      else currentSlide = currentSlide3.value;

      track.style.transform = `translateX(-${currentSlide * 100}%)`;
    };

    // Prevenir el comportamiento por defecto durante el drag
    const preventDefault = (e) => {
      if (isDragging) {
        e.preventDefault();
      }
    };

    track.addEventListener('touchstart', handleTouchStart, { passive: false });
    track.addEventListener('touchmove', handleTouchMove, { passive: false });
    track.addEventListener('touchend', handleTouchEnd);
    track.addEventListener('touchcancel', handleTouchEnd);
  });
};

onMounted(() => {
  setupCarousel();
});
</script>

<template>
  <!-- HERO PANTALLA COMPLETA -->
  <div class="fullscreen-hero">
    <div class="hero-content">
      <h1 class="hero-title">EJEMPLOS</h1>
      <p class="hero-subtitle">Desarrollo y actualización web</p>
    </div>
    <!-- CÍRCULOS FLOTANTES (igual que servicios) -->
    <div class="floating-circles">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
    </div>
  </div>

  <!-- SECCIÓN PRINCIPAL -->
  <section class="examples-section">
    <div class="container">

      <!-- SERVICIO 1: DESKTOP GRID / MÓVIL CARRUSEL -->
      <div class="service-section">
        <h2 class="service-title">Desarrollo y actualización web</h2>

        <!-- DESKTOP: Grid 3x2 -->
        <div class="examples-grid-desktop">
          <div class="example-card" v-for="project in projects1" :key="project.id"
               @mouseenter="hoverCard(project.id)"
               @mouseleave="resetCard(project.id)">
            <div class="card-image-container">
              <div class="card-image" :style="{ background: project.color }"></div>
              <div class="card-overlay" :class="{ active: hoverStates[project.id] }">
                <div class="overlay-content">
                  <p>{{ project.description }}</p>
                  <RouterLink
                    :to="project.demoRoute"
                    class="demo-btn"
                    @click="navigateToDemo(project.demoRoute, project.id, $event)"
                  >
                    Ver Demo
                  </RouterLink>
                </div>
              </div>
            </div>
            <div class="card-name">{{ project.name }}</div>
          </div>
        </div>

        <!-- MÓVIL: Carrusel idéntico a servicios -->
        <div class="examples-carousel-mobile">
          <div class="carousel-container">
            <div class="carousel-track" :style="{ transform: `translateX(-${currentSlide1 * 100}%)` }">
              <div class="carousel-slide" v-for="project in projects1" :key="project.id">
                <div class="carousel-card">
                  <div class="carousel-image" :style="{ background: project.color }"></div>
                  <h3 class="carousel-title">{{ project.name }}</h3>
                  <p class="carousel-description">{{ project.description }}</p>
                  <RouterLink
                    :to="project.demoRoute"
                    class="carousel-demo-btn"
                    @click="navigateToDemo(project.demoRoute, project.id, $event)"
                  >
                    Ver Demo
                  </RouterLink>
                  <div class="carousel-indicator">
                    <span>👆 Toca para detalles</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- INDICADOR DE DESLIZAMIENTO -->
          <div class="carousel-swipe-indicator">
            <div class="swipe-animation">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <path d="M14 7l-5 5 5 5" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span class="swipe-text">Desliza para explorar</span>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <path d="M10 7l5 5-5 5" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="slide-counter">
              {{ currentSlide1 + 1 }}/{{ projects1.length }}
            </div>
          </div>
        </div>
      </div>

      <!-- SERVICIO 2 -->
      <div class="service-section">
        <h2 class="service-title">Servicio 2</h2>

        <!-- DESKTOP: Grid -->
        <div class="examples-grid-desktop">
          <div class="example-card" v-for="project in projects2" :key="project.id"
               @mouseenter="hoverCard(project.id)"
               @mouseleave="resetCard(project.id)">
            <div class="card-image-container">
              <div class="card-image" :style="{ background: project.color }"></div>
              <div class="card-overlay" :class="{ active: hoverStates[project.id] }">
                <div class="overlay-content">
                  <p>{{ project.description }}</p>
                  <RouterLink
                    :to="project.demoRoute"
                    class="demo-btn"
                    @click="navigateToDemo(project.demoRoute, project.id, $event)"
                  >
                    Ver Demo
                  </RouterLink>
                </div>
              </div>
            </div>
            <div class="card-name">{{ project.name }}</div>
          </div>
        </div>

        <!-- MÓVIL: Carrusel -->
        <div class="examples-carousel-mobile">
          <div class="carousel-container">
            <div class="carousel-track" :style="{ transform: `translateX(-${currentSlide2 * 100}%)` }">
              <div class="carousel-slide" v-for="project in projects2" :key="project.id">
                <div class="carousel-card">
                  <div class="carousel-image" :style="{ background: project.color }"></div>
                  <h3 class="carousel-title">{{ project.name }}</h3>
                  <p class="carousel-description">{{ project.description }}</p>
                  <RouterLink
                    :to="project.demoRoute"
                    class="carousel-demo-btn"
                    @click="navigateToDemo(project.demoRoute, project.id, $event)"
                  >
                    Ver Demo
                  </RouterLink>
                  <div class="carousel-indicator">
                    <span>👆 Toca para detalles</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="carousel-swipe-indicator">
            <div class="swipe-animation">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <path d="M14 7l-5 5 5 5" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span class="swipe-text">Desliza para explorar</span>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <path d="M10 7l5 5-5 5" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="slide-counter">
              {{ currentSlide2 + 1 }}/{{ projects2.length }}
            </div>
          </div>
        </div>
      </div>

      <!-- SERVICIO 3 -->
      <div class="service-section">
        <h2 class="service-title">Servicio 3</h2>

        <!-- DESKTOP: Grid -->
        <div class="examples-grid-desktop">
          <div class="example-card" v-for="project in projects3" :key="project.id"
               @mouseenter="hoverCard(project.id)"
               @mouseleave="resetCard(project.id)">
            <div class="card-image-container">
              <div class="card-image" :style="{ background: project.color }"></div>
              <div class="card-overlay" :class="{ active: hoverStates[project.id] }">
                <div class="overlay-content">
                  <p>{{ project.description }}</p>
                  <RouterLink
                    :to="project.demoRoute"
                    class="demo-btn"
                    @click="navigateToDemo(project.demoRoute, project.id, $event)"
                  >
                    Ver Demo
                  </RouterLink>
                </div>
              </div>
            </div>
            <div class="card-name">{{ project.name }}</div>
          </div>
        </div>

        <!-- MÓVIL: Carrusel -->
        <div class="examples-carousel-mobile">
          <div class="carousel-container">
            <div class="carousel-track" :style="{ transform: `translateX(-${currentSlide3 * 100}%)` }">
              <div class="carousel-slide" v-for="project in projects3" :key="project.id">
                <div class="carousel-card">
                  <div class="carousel-image" :style="{ background: project.color }"></div>
                  <h3 class="carousel-title">{{ project.name }}</h3>
                  <p class="carousel-description">{{ project.description }}</p>
                  <RouterLink
                    :to="project.demoRoute"
                    class="carousel-demo-btn"
                    @click="navigateToDemo(project.demoRoute, project.id, $event)"
                  >
                    Ver Demo
                  </RouterLink>
                  <div class="carousel-indicator">
                    <span>👆 Toca para detalles</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="carousel-swipe-indicator">
            <div class="swipe-animation">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <path d="M14 7l-5 5 5 5" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span class="swipe-text">Desliza para explorar</span>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <path d="M10 7l5 5-5 5" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="slide-counter">
              {{ currentSlide3 + 1 }}/{{ projects3.length }}
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<style scoped>
/* ESTILOS PARA LOS RouterLink COMO BOTONES */
.demo-btn,
.carousel-demo-btn {
  display: inline-block;
  background: var(--color-primary);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  text-align: center;
}

.demo-btn:hover,
.carousel-demo-btn:hover {
  background: #0a58ca;
  transform: translateY(-2px);
  color: white;
  text-decoration: none;
}

/* Para el carrusel, hacer que el botón ocupe todo el ancho */
.carousel-demo-btn {
  width: 100%;
  margin-bottom: 1rem;
}

/* EL RESTO DE LOS ESTILOS SE MANTIENEN IGUAL */
.fullscreen-hero {
  background: linear-gradient(135deg, var(--color-background) 0%, #1a1f2e 100%);
  color: var(--color-text-primary);
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 50px !important;
}

.hero-content {
  position: relative;
  z-index: 10;
  text-align: center;
}

.hero-title {
  font-size: 4rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: var(--color-text-primary);
}

.hero-subtitle {
  font-size: 1.5rem;
  color: var(--color-text-secondary);
  margin: 0;
}

/* ... (el resto de los estilos se mantienen igual) ... */

/* RESPONSIVE BREAKPOINTS */
/* DESKTOP: ≥ 992px - Grid 3x2 */
@media (min-width: 992px) {
  .examples-grid-desktop { display: grid; }
  .examples-carousel-mobile { display: none; }
}

/* MÓVIL: < 992px - Carrusel */
@media (max-width: 991px) {
  .examples-grid-desktop { display: none; }
  .examples-carousel-mobile { display: block; }

  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1.2rem;
  }

  .fullscreen-hero {
    height: 100vh;
    padding: 0 20px;
  }
}

/* MÓVIL PEQUEÑO: ≤ 480px */
@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .service-title {
    font-size: 1.8rem;
  }

  .carousel-container {
    height: 380px;
  }

  .carousel-slide {
    height: 380px;
  }

  .carousel-card {
    padding: 1.5rem;
    margin: 0 0.5rem;
  }
}

/* HERO PANTALLA COMPLETA */
.fullscreen-hero {
  background: linear-gradient(135deg, var(--color-background) 0%, #1a1f2e 100%);
  color: var(--color-text-primary);
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 60px !important;
}

.hero-content {
  position: relative;
  z-index: 10;
  text-align: center;
}

.hero-title {
  font-size: 4rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: var(--color-text-primary);
}

.hero-subtitle {
  font-size: 1.5rem;
  color: var(--color-text-secondary);
  margin: 0;
}

/* CÍRCULOS FLOTANTES (igual que servicios) */
.floating-circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.4;
}

.circle-1 {
  width: 120px;
  height: 120px;
  top: 20%;
  left: 10%;
  background: linear-gradient(135deg, #3c27ffe7 0%, #4636dad7 50%, #2d5ee6d7 100%);
  animation: float 6s ease-in-out infinite;
}

.circle-2 {
  width: 80px;
  height: 80px;
  top: 60%;
  right: 15%;
  background: linear-gradient(135deg, #0f96a8 0%, #21c8dfdc 50%, #9dbdff 100%);
  animation: float 8s ease-in-out infinite 1s;
}

.circle-3 {
  width: 150px;
  height: 150px;
  bottom: 10%;
  left: 20%;
  background: linear-gradient(135deg, #3c27ffe7 0%, #4636dad7 50%, #2d5ee6d7 100%);
  animation: float 10s ease-in-out infinite 2s;
}

.circle-4 {
  width: 100px;
  height: 100px;
  top: 30%;
  right: 25%;
  background: linear-gradient(135deg, #0f96a8 0%, #21c8dfdc 50%, #9dbdff 100%);
  animation: float 7s ease-in-out infinite 1.5s;
}

@keyframes float {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-20px) scale(1.05); }
}

/* SECCIÓN PRINCIPAL */
.examples-section {
  background: var(--color-surface);
  padding: 80px 20px;
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

/* SERVICIOS */
.service-section {
  margin-bottom: 100px;
}

.service-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: var(--color-text-primary);
  text-align: center;
  margin-bottom: 3rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--color-primary);
  display: inline-block;
}

/* DESKTOP: Grid 3x2 */
.examples-grid-desktop {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.example-card {
  background: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.example-card:hover {
  transform: translateY(-5px);
}

.card-image-container {
  position: relative;
  width: 100%;
  height: 250px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.card-image {
  width: 100%;
  height: 100%;
  transition: all 0.3s ease;
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  backdrop-filter: blur(0px);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.card-overlay.active {
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  opacity: 1;
}

.overlay-content {
  text-align: center;
  color: white;
  padding: 2rem;
}

.overlay-content p {
  margin-bottom: 1.5rem;
  font-size: 1rem;
  line-height: 1.5;
}

.demo-btn {
  background: var(--color-primary);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.demo-btn:hover {
  background: #0a58ca;
  transform: translateY(-2px);
}

.card-name {
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-top: 1rem;
  padding: 0.5rem;
}

/* MÓVIL: Carrusel (idéntico a servicios) */
.examples-carousel-mobile {
  display: none;
  position: relative;
}

.carousel-container {
  overflow: hidden;
  border-radius: 16px;
  height: 400px;
}

.carousel-track {
  display: flex;
  transition: transform 0.3s ease;
  width: 100%;
}

.carousel-slide {
  flex: 0 0 100%;
  min-width: 100%;
  height: 400px;
  display: flex;
  align-items: stretch;
}

.carousel-card {
  background: var(--color-background);
  border-radius: 16px;
  padding: 2rem;
  margin: 0 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-height: 350px;
}

.carousel-image {
  width: 100%;
  height: 150px;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.carousel-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: var(--color-text-primary);
  margin-bottom: 1rem;
  text-align: center;
}

.carousel-description {
  color: var(--color-text-secondary);
  margin-bottom: 1.5rem;
  line-height: 1.5;
  text-align: center;
  flex: 1;
}

.carousel-demo-btn {
  background: var(--color-primary);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  margin-bottom: 1rem;
}

.carousel-demo-btn:hover {
  background: #0a58ca;
}

.carousel-indicator {
  text-align: center;
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* INDICADOR DE DESLIZAMIENTO (igual que servicios) */
.carousel-swipe-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding: 1rem;
  width: 100%;
}

.swipe-animation {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  animation: pulse-swipe 2s infinite;
}

.swipe-text {
  color: var(--color-primary);
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
}

.slide-counter {
  background: rgba(92, 141, 246, 0.1);
  color: var(--color-primary);
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid var(--color-primary);
}

@keyframes pulse-swipe {
  0%, 100% { opacity: 0.7; transform: translateX(0); }
  50% { opacity: 1; transform: translateX(5px); }
}

/* RESPONSIVE BREAKPOINTS */
/* DESKTOP: ≥ 992px - Grid 3x2 */
@media (min-width: 992px) {
  .examples-grid-desktop { display: grid; }
  .examples-carousel-mobile { display: none; }
}

/* MÓVIL: < 992px - Carrusel */
@media (max-width: 991px) {
  .examples-grid-desktop { display: none; }
  .examples-carousel-mobile { display: block; }

  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1.2rem;
  }

  .fullscreen-hero {
    height: 100vh;
    padding: 0 20px;
  }
}

/* MÓVIL PEQUEÑO: ≤ 480px */
@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .service-title {
    font-size: 1.8rem;
  }

  .carousel-container {
    height: 380px;
  }

  .carousel-slide {
    height: 380px;
  }

  .carousel-card {
    padding: 1.5rem;
    margin: 0 0.5rem;
  }
}
</style>
